import { Type } from 'class-transformer';

import { IViewModel } from '../../interfaces/view-model.interface';
import { FolderRolePermissionExpression } from './folder-role-permission-expression.model';

export class FolderPermissionExpression implements IViewModel {
    public id: number;

    public dataCollectionId: number;

    public name: string;
    public tag: string; // A shorter name, if necessary, that can be shown in the folder tree (and used to help with 508 compliance).
    public description: string;

    // RGBA values for color coding a permission expression so it can be distinguished from others.
    public rgbaBytesAsCommaDelimitedValues: string;
    private rgbaBytes: Int8Array = null;
    public loadRgbaBytesFromDelimitedValues(): void {
        if (this.rgbaBytes == null)
            this.rgbaBytes = new Int8Array(4);

        for (let index: number = 0; index < this.rgbaBytes.length; index++) 
            this.rgbaBytes[index] = 0;

        if (this.rgbaBytesAsCommaDelimitedValues != null) {
            let arrValues: string[] = this.rgbaBytesAsCommaDelimitedValues.split(',');
            for (let index: number = 0; (index < arrValues.length) && (index < this.rgbaBytes.length); index++) {
                let value: string = arrValues[index];
                this.rgbaBytes[index] = parseInt(value);
            }                            
        }
    }
    public get colorRedValue(): number {
        return this.getRgbaByteValue(0);
    }
    public set colorRedValue(value: number) {
        this.setRgbaValue(0, value);
    }
    public get colorGreenValue(): number {
        return this.getRgbaByteValue(1);
    }
    public set colorGreenValue(value: number) {
        this.setRgbaValue(1, value);
    }
    public get colorBlueValue(): number {
        return this.getRgbaByteValue(2);
    }
    public set colorBlueValue(value: number) {
        this.setRgbaValue(2, value);
    }
    public get colorAlphaValue(): number {
        return this.getRgbaByteValue(3);
    }
    public set colorAlphaValue(value: number) {
        this.setRgbaValue(3, value);
    }
    private getRgbaByteValue(index: number): number {
        if (this.rgbaBytes == null)
            this.loadRgbaBytesFromDelimitedValues();

        return this.rgbaBytes[index];
    }
    private setRgbaValue(byteIndex: number, value: number): void {
        if (this.rgbaBytes == null)
            this.rgbaBytes = new Int8Array(4);

        this.rgbaBytes[byteIndex] = value;

        let rgbaBytesAsCommaDelimitedValues: string = '';
        for (let index: number = 0; index < this.rgbaBytes.length; index++) {
            if (index > 0)
                rgbaBytesAsCommaDelimitedValues += ',';
            rgbaBytesAsCommaDelimitedValues += this.rgbaBytes[index].toString();
        }

        this.rgbaBytesAsCommaDelimitedValues = rgbaBytesAsCommaDelimitedValues;
    }

    public canBeSelectedForFolders: boolean = true; // That is, if a user has 'grant' for a folder, and that folder's permission expression is not locked,
                                                    // then this permission expression can show up in a pick list of available permission expressions.

    public isDefaultPermissionExpressionFlag: boolean = false; // The built-in/standard permission expression that is assigned to a site's root folder during site creation.
                                                                    // This permission expression would have the intuitive permissions for each of the standard/built-in roles.
    public isBuiltInPermissionExpressionFlag: boolean = false; // Indicates that this is one of the standard, built-in permission expressions created for new sites.

    @Type(() => FolderRolePermissionExpression)
    public folderRolePermissionExpressions: FolderRolePermissionExpression[];
}
